module.exports = __webpack_public_path__ + "img/more.24bbfcc5.svg";